import {getMenuList, deleteMenuById, editMenuById, getOwnerBtns} from 'api/menu';
import {showSucMsg} from 'common/js/util';
import { getDictList } from 'api/dict';

const PREFIX = 'SYSTEM_MENU_';
const SET_BUTTON_LIST = PREFIX + 'SET_BUTTON_LIST';
const LOADING = PREFIX + 'LOADING';
const CANCEL_LOADING = PREFIX + 'CANCEL_LOADING';
const SET_TREE_DATA = PREFIX + 'SET_TREE_DATA';
const SET_PARENTTREE_DATA = PREFIX + 'SET_PARENTTREE_DATA';
const SET_MENU_INFO = PREFIX + 'SET_MENU_INFO';
const SET_SELECT_DATA = PREFIX + 'SET_SELECT_DATA';
const SET_SELECTED_KEYS = PREFIX + 'SET_SELECTED_KEYS';
const SET_CHECKED_KEYS = PREFIX + 'SET_CHECKED_KEYS';
const SET_EXPANDED_KEYS = PREFIX + 'SET_EXPANDED_KEYS';

const initState = {
    fetching: false,
    msg: '',
    btnList: [],
    treeData: [],
    parentTreeData: [],
    menuInfo: {},
    defaultExpandedKeys: [],
    checkedKeys: [],
    selectedKeys: [],
    selectData: {}
};

let listInfo = {};
let menuInfo = {};
let selectData = {};

export function systemMenu(state = initState, action) {
    switch (action.type) {
        case SET_BUTTON_LIST:
            return {...state, btnList: action.payload};
        case SET_TREE_DATA:
            return {...state, msg: '', treeData: action.payload};
        case SET_PARENTTREE_DATA:
            return {...state, msg: '', parentTreeData: action.payload};
        case SET_MENU_INFO:
            return {...state, msg: '', menuInfo: action.payload};
        case SET_SELECT_DATA:
            return {...state, msg: '', selectData: action.payload};
        case SET_SELECTED_KEYS:
            return {...state, msg: '', selectedKeys: action.payload};
        case SET_CHECKED_KEYS:
            return {...state, msg: '', checkedKeys: action.payload};
        case SET_EXPANDED_KEYS:
            return {...state, msg: '', defaultExpandedKeys: action.payload};
        case LOADING:
            return {...state, fetching: true};
        case CANCEL_LOADING:
            return {...state, fetching: false};
        default:
            return state;
    }
}

// 显示loading
export function doFetching() {
    return {type: LOADING};
}

// 隐藏loading
export function cancelFetching() {
    return {type: CANCEL_LOADING};
}

// 设置页面的按钮
export function setBtnList(data) {
    return {type: SET_BUTTON_LIST, payload: data};
}

// 设置treeData
export function setTreeData(data) {
    return {type: SET_TREE_DATA, payload: data};
}

// 设置treeData
export function setParentTreeData(data) {
    return {type: SET_PARENTTREE_DATA, payload: data};
}

// 设置menuInfo
export function setMenuInfo(data) {
    return {type: SET_MENU_INFO, payload: data};
}

// 设置menuInfo
export function getMenuInfo(data) {
    return {type: SET_MENU_INFO, payload: data};
}

// 设置选中的keys
export function _setSelectedKeys(keys) {
    return {type: SET_SELECTED_KEYS, payload: keys};
}

// 设置checkbox选中的keys
export function _setCheckedKeys(keys) {
    return {type: SET_CHECKED_KEYS, payload: keys};
}

// 设置选中的keys
export function setSelectedKeys(keys, setFieldsValue) {
    return dispatch => {
        dispatch(_setSelectedKeys(keys));
        dispatch(_setCheckedKeys(keys));
        let current = keys.length ? menuInfo[keys[0]] : {};
        setFieldsValue({
            id: current.id,
            parentId: current.parentId || '',
            name: current.name || '',
            url: current.url || '',
            type: current.type || '',
            orderNo: current.orderNo || '',
            kind: current.kind || '',
            location: current.location || '',
            remark: current.remark || ''
        });
    };
}

// 设置defaultExpandedKeys
export function setExpandedKeys(keys) {
    return {type: SET_EXPANDED_KEYS, payload: keys};
}

// 新增菜单
export function add(menu) {
    return dispatch => {
        let parentId = menu.parentId;
        listInfo[parentId] = listInfo[parentId] || [];
        menuInfo[menu.id] = menu;
        listInfo[parentId].push({
            title: menu.name,
            key: menu.id.toString(),
            type: menu.type
        });
        let tree = [];
        getTreeNode(listInfo['ROOT'], tree);
        dispatch(setTreeData(tree));
        dispatch(setMenuInfo(menuInfo));
    };
}

// 删除菜单
export function deleteMenu(id) {
    return dispatch => {
        dispatch(doFetching());
        deleteMenuById(id).then(() => {
            dispatch(cancelFetching());
            showSucMsg('删除成功');
            let parentId = menuInfo[id].parentId;
            let idx = listInfo[parentId].findIndex(v => v.key === id);
            listInfo[parentId].splice(idx, 1);
            let tree = [];
            getTreeNode(listInfo['ROOT'], tree);
            dispatch(setTreeData(tree));
        }).catch(() => {
            dispatch(cancelFetching());
        });
    };
}

// 更新菜单
export function editMenu(params) {
    return dispatch => {
        dispatch(doFetching());
        editMenuById(params).then(() => {
            dispatch(cancelFetching());
            showSucMsg('修改成功');
            params.parentId = params.parentId || 'ROOT';
            menuInfo[params.id] = params;
            listInfo[params.parentId].map((v, i) => {
                if (v.key === params.id) {
                    listInfo[params.parentId][i] = {
                        key: params.id,
                        title: params.name,
                        type: params.type
                    };
                }
            });
            let tree = [];
            getTreeNode(listInfo['ROOT'], tree);
            dispatch(setTreeData(tree));
            dispatch(setMenuInfo(menuInfo));
            dispatch(initData());
        }).catch(() => {
            dispatch(cancelFetching());
        });
    };
}

export function setSelectData(data) {
    return {type: SET_SELECT_DATA, payload: data};
}

// 页面初始化
export function initData() {
    return (dispatch, getState) => {
        dispatch(doFetching());
        Promise.all([
            getDictList({parentKey: 'menu.kind'}),
            getDictList({parentKey: 'menu.type'}),
            getDictList({parentKey: 'menu.button.location'})
        ]).then(([kindData, typeData, locationData]) => {
            selectData['kind'] = kindData;
            selectData['kindList'] = {};
            kindData.map(d => {
                selectData['kindList'][d.dkey] = d.dvalue;
            });
            selectData['type'] = typeData;
            selectData['typeList'] = {};
            typeData.map(d => {
                selectData['typeList'][d.dkey] = d.dvalue;
            });
            selectData['location'] = locationData;
            selectData['locationList'] = {};
            locationData.map(d => {
                selectData['locationList'][d.dkey] = d.dvalue;
            });
        });
        Promise.all([
            getOwnerBtns(getState().menu.subMenuCode),
            getMenuList({sort: 'orderNo'})
        ]).then(([btnData, menuData]) => {
            dispatch(setBtnList(btnData));
            getTree(menuData, dispatch);
            dispatch(_setSelectedKeys([]));
            dispatch(_setCheckedKeys([]));
            dispatch(cancelFetching());
        }).catch(() => {
            dispatch(cancelFetching());
        });
    };
}

// 生成数结构步骤1
export function getTree(data, dispatch) {
    let result = {};
    let info = {};
    let parentIdData = {
        'parentId': []
    };
    let parentTree = [];
    data.forEach(v => {
        v.parentId = v.parentId || 'ROOT';
        v.parentId = v.parentId.toString();
        v.id = v.id.toString();
        if (v.type !== 'button') {
            parentTree.push(v);
        }
        if (!result[v.parentId]) {
            result[v.parentId] = [];
        }
        info[v.id] = v;
        result[v.parentId].push({
            title: v.name,
            key: v.id,
            type: v.type
        });
        let kindName = '';
        if (selectData['kindList']) {
            kindName = selectData['kindList'][v.kind];
        }
        let locationName = '';
        if(selectData['locationList']) {
            locationName = selectData['locationList'][v.kind];
        }
        parentIdData['parentId'].push({
            id: v.id,
            name: v.id + ' ' + v.name + ' ' + kindName
        });
    });
    listInfo = result;
    menuInfo = info;
    let tree = [];
    getTreeNode(listInfo['ROOT'], tree);
    dispatch(setExpandedKeys([listInfo['ROOT'][0].key]));
    dispatch(setTreeData(tree));
    dispatch(setParentTreeData(parentTree));
    dispatch(setMenuInfo(menuInfo));
    dispatch(setSelectData({...selectData, ...parentIdData}));
}

// 生成数结构步骤2
export function getTreeNode(arr, children, pTree) {
    arr.forEach(a => {
        if (listInfo[a.key]) {
            a.children = [];
            children.push(a);
            getTreeNode(listInfo[a.key], a.children);
        } else {
            children.push(a);
        }
    });
}
